import React, { Component } from "react";
import ArchiveChaptersPanel from "./ArchiveChaptersPanel";

export default class DraftChaptersPanel extends Component {
  render() {
    const { chapters = [], ...rest } = this.props;

    return (
      <ArchiveChaptersPanel
        {...rest}
        title="Drafts"
        emptyText="No drafts yet"
        sectionStatus="draft"
        chapters={chapters}
      />
    );
  }
}
